var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "home"
  }, [_c('div', {
    staticClass: "intro"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "intro__body"
  }, [_c('vue-logo-icon', {
    staticClass: "intro__logo"
  }), _c('h1', {
    staticClass: "intro__title"
  }, [_vm._v(" Vue UI Kit ")])], 1)])]), _c('div', {
    staticClass: "components"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "components__grid"
  }, [_c('div', {
    staticClass: "components__col"
  }, [_c('h2', {
    staticClass: "components__caption"
  }, [_vm._v(" Components ")]), _c('ul', {
    staticClass: "components__item-list"
  }, [_c('li', {
    staticClass: "components__item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'breadcrumbs'
      }
    }
  }, [_vm._v(" Breadcrumbs ")])], 1), _c('li', {
    staticClass: "components__item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'button'
      }
    }
  }, [_vm._v(" Button ")])], 1), _c('li', {
    staticClass: "components__item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'checkbox'
      }
    }
  }, [_vm._v(" Checkbox ")])], 1), _c('li', {
    staticClass: "components__item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'expansion-panel'
      }
    }
  }, [_vm._v(" Expansion panel ")])], 1), _c('li', {
    staticClass: "components__item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'modal'
      }
    }
  }, [_vm._v(" Modal ")])], 1), _c('li', {
    staticClass: "components__item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'pagination'
      }
    }
  }, [_vm._v(" Pagination ")])], 1), _c('li', {
    staticClass: "components__item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'progress-circular'
      }
    }
  }, [_vm._v(" Progress circular ")])], 1), _c('li', {
    staticClass: "components__item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'progress-linear'
      }
    }
  }, [_vm._v(" Progress linear ")])], 1), _c('li', {
    staticClass: "components__item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'radio'
      }
    }
  }, [_vm._v(" Radio ")])], 1), _c('li', {
    staticClass: "components__item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'rating'
      }
    }
  }, [_vm._v(" Rating ")])], 1), _c('li', {
    staticClass: "components__item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'side-panel'
      }
    }
  }, [_vm._v(" Side panel ")])], 1), _c('li', {
    staticClass: "components__item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'stepper'
      }
    }
  }, [_vm._v(" Stepper ")])], 1), _c('li', {
    staticClass: "components__item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'switcher'
      }
    }
  }, [_vm._v(" Switcher ")])], 1), _c('li', {
    staticClass: "components__item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'tabs'
      }
    }
  }, [_vm._v(" Tabs ")])], 1), _c('li', {
    staticClass: "components__item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'uploader'
      }
    }
  }, [_vm._v(" Uploader ")])], 1)])]), _c('div', {
    staticClass: "components__col"
  }, [_c('h2', {
    staticClass: "components__caption"
  }, [_vm._v(" Blocks ")]), _c('ul', {
    staticClass: "components__item-list"
  }, [_c('li', {
    staticClass: "components__item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'container'
      }
    }
  }, [_vm._v(" Container ")])], 1), _c('li', {
    staticClass: "components__item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'aspect-ratio'
      }
    }
  }, [_vm._v(" Aspect ratio ")])], 1), _c('li', {
    staticClass: "components__item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'skeleton'
      }
    }
  }, [_vm._v(" Skeleton ")])], 1)])])])])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }